
export const APIURL =
  import.meta.env.VITE_ENVIRONMENT === "PROD"
    ? "https://entntcareersapi.azurewebsites.net/api"
    : import.meta.env.VITE_ENVIRONMENT === "TEST"
      ? "https://testentntcareersapi-ebdzgyenhpdwbjfj.centralindia-01.azurewebsites.net/api"
      : "https://localhost:7154/api";

export type paginationData = {
  totalCount: number;
  pageSize: number;
  currentPage: number;
  totalPages: number;
};
 
export interface SectionGenerationData {
  title: string;
  orderIndex: number;
  hasBreakAfter: boolean;
  numOfQuestions: number;
  skillMappings: {
    skillId: string;
    questionPercentage: number;
    difficultyMin: number;
    difficultyMax: number;
    variationMin: number;
    variationMax: number;
    aboveThresholdQuestions: number;
    belowThresholdQuestions: number;
  }[];
}

export interface Filters {
  FilterType: string;
  MinCount?: number;
  MaxCount?: number;
  Locations?: (string | number | boolean | null)[];
  Tags?: string[];
}

export interface MergeRequest {
  correctCityId: string;
  duplicateCityIds: string[];
}